import { FC } from "react";
import { ReactComponent as ChairSVG } from "../../../../../../../../../../../../images/svg/rooms/chair.svg";
import { RoomTableApi } from "../../../../../../../../../../../../services/Api/Organization/types";

interface Props {
	name?: string;
	guestAmount?: number;
	handleCreate?: (roomTable: RoomTableApi) => void;
}

const RectangleVertical: FC<Props> = ({ name, guestAmount, handleCreate }) => {
	const onCreate = () => {
		const obj = {
			type: "RECTANGLE",
			width: 96,
			height: 132,
			number_of_seats: guestAmount,
			position_top: 50,
			position_left: 50,
			name: "",
		} as RoomTableApi;
		if (handleCreate) {
			handleCreate(obj);
		}
	};

	return (
		<div className={"table-box box-RECTANGLE-vertical"} onClick={onCreate}>
			{guestAmount && guestAmount > 0 && (
				<div className={"box-chair"}>
					<ChairSVG /> {guestAmount}
				</div>
			)}
			<div className={"box-small"}>{name ? name : "#"}</div>
		</div>
	);
};
export default RectangleVertical;
